import React, { useState, useEffect, useContext, useMemo } from 'react';

import * as Sentry from '@sentry/react';

import { useHistory, useLocation } from 'react-router-dom';
import { useForm, Controller, useWatch } from 'react-hook-form';

import { FiltersContext } from 'context/GlobalFiltersContext';
import { GlobalComponentsContext } from 'context/GlobalComponentsContext';
import { AuthContext } from 'context/AuthContext';
import { getLocalAuthStorage } from 'utils/localStorage';

import { HeaderFiltersPage } from 'containers/HeaderFiltersPage';

//import { Menu } from 'components/Menu';
import { MobileNavbar } from 'components/MobileNavbar';
import { PageWrapper } from 'components/PageWrapper';

import { Toast } from 'components/Toast';
import { Loading } from 'components/Loading';
import { FilterModal } from 'components/FilterModal';

import { FieldRow } from 'components/Form/subcomponents/FieldRow';
import { FormGroup } from 'components/Form/subcomponents/FormGroup';
import { DateRangePicker } from 'components/Form/subcomponents/DateRangePicker';
import { Select } from 'components/Form/subcomponents/Select';
import { Switch } from 'components/Form/subcomponents/Switch';
import MultiSelect from 'components/Form/subcomponents/MultiSelect';
import { Radio } from 'components/Form/subcomponents/Radio';

import { PageHeader } from 'components/PageHeader';
//import { ReportContainer } from 'components/ReportContainer';
import { ReportContainerTabs } from 'components/ReportContainerTabs';
import { ReportContainerFillFields } from 'components/ReportContainer/subcomponents/ReportContainerFillFields';
import { ReportContainerFields } from 'components/ReportContainer/subcomponents/ReportContainerFields';
import { ReportContainerColumn } from 'components/ReportContainer/subcomponents/ReportContainerColumn';
import { LineSeparator } from 'components/ReportContainer/subcomponents/LineSeparator';
import ReportTable from 'components/Tables/ReportTable';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import { ReactComponent as EmailSuccessIcon } from 'assets/icons/rel-success-icon.svg';
import { ReactComponent as EmailAtentionIcon } from 'assets/icons/atention-icon.svg';
import { PmocService, SavedFiltersService, FiltersService, ReportService } from 'services/reports';

import { createErrorToast, createGenericErrorToast, createToast } from 'utils/createToast';

import { colors } from 'assets/styled/tokens';

import {
  SendPmocEmailSuccessModal,
  StyledCertificateTypeRadioContainer,
  StyledResponsibleFormContainer,
  StyledAddResponsibleButton,
  RemoveSecondResponsibleButton,
  EmailNotVerifiedWarningContainer,
  Header,
  GoBackButton,
  AtentionModal,
  StatusInfo,
  StyledWarningIcon,
  StatusWarningInfo,
  KnowMoreButton,
  RedoReportButton,
} from './styled';

import { GridColumn } from 'components/Grid/GridColumn';
import Accordion from 'components/Accordion';
import { InfoLink } from 'components/InfoLink';
import { Textarea } from 'components/Form/subcomponents/Textarea';
import { adaptReportsApiOptions } from 'utils/helpers/adapters';
import { Button } from 'components/Button';
import { DownloadButton } from 'components/Tables/ReportTable/styles';
import { Spinner } from 'components/Spinner';
import { NewMenu } from 'components/Menu/NewMenu';

const reportName = 'pmoc';

const Pmoc = ({ pathname }) => {
  const { authContext } = useContext(AuthContext);
  const { user, token } = authContext;

  const { globalComponentsContext, setGlobalComponentsContext } = useContext(GlobalComponentsContext);
  const { isLoading } = globalComponentsContext;

  const { headerFiltersContext } = useContext(FiltersContext);
  const { headerFilters } = headerFiltersContext;
  const authStorage = getLocalAuthStorage();

  const history = useHistory();

  const {
    handleSubmit,
    register,
    setValue,
    watch,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      responsible1: { certificate: 'ART' },
      responsible2: { certificate: 'ART' },
    },
  });

  const [isFirstMount, setIsFirstMount] = useState(true);
  const [isSendPmocEmailSuccess, setIsSendPmocEmailSuccess] = useState(false);
  const [duplicatedReport, setDuplicatedReport] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [toastList, setToastList] = useState([]);
  const [active, setActive] = useState(false);

  const [fields, setFields] = useState({
    unitGroups: [],
    unitSubgroups: [],
    units: [],
    responsibles: [],
    responsiblesARTCertificateDocuments: undefined,
    responsiblesTRTCertificateDocuments: undefined,
    showEquipmentsImages: true,
    showAditionalInformation: true,
    showJustificationsOfNonRealizedActivities: true,
    extraDocuments: [],
    systems: [],
    generatedReports: [],
  });

  const [isSecondResponsibleFormActive, setIsSecondResponsibleFormActive] = useState(false);
  const [currentSavedFilter, setCurrentSavedFilter] = useState('');

  const [modalOptions, setModalOptions] = useState({
    open: false,
    propertyKey: null,
  });

  const goback = () => history.push('/relatorios');

  // Used to get PDF names to send on payload
  const getDocumentLabels = (selectedDocuments, documentsList) => {
    // Get only the selected items detailed object
    const detailedSelectedDocuments = documentsList.filter(document => selectedDocuments.includes(document.value));
    let formattedDocumentsPayload = [];

    // Format the payload according to the API documentation
    detailedSelectedDocuments.forEach(document => {
      formattedDocumentsPayload = [...formattedDocumentsPayload, { nome: document.label, link: document.value }];
    });

    return formattedDocumentsPayload;
  };

  const formatPayload = ({
    unit,
    systems,
    period,
    activitiesPlans,
    showAditionalInformation,
    showEquipmentsImages,
    showJustificationsOfNonRealizedActivities,
    responsible1,
    responsible2,
    failuresAndEmergenciesRecommendations,
    extraDocuments,
  }) => {
    const [startDate, endDate] = period.split('/');
    const responsibles = [
      {
        responsavel: responsible1.id,
        certificado: 1,
        documento: responsible1.document,
      },
    ];
    if (responsible2) {
      responsibles.push({
        responsavel: responsible2.id,
        certificado: 1,
        documento: responsible2.document,
      });
    }
    const startDateTimestamp = 'T00:00:00.543Z';
    const endDateTimestamp = 'T23:59:59.543Z';
    const startDateTime = startDate + startDateTimestamp;
    const endDateTime = endDate + endDateTimestamp;
    const additionalDocuments = getDocumentLabels(extraDocuments, fields.documents);

    return {
      login: user?.name,
      empresa: headerFilters?.companies?.id,
      dataInicial: startDateTime,
      dataFinal: endDateTime,
      unidade: unit,
      sistemas: systems.map(system => parseInt(system)),
      planoAtividades: activitiesPlans.map(plan => parseInt(plan)),
      responsaveisTecnicos: responsibles,
      ativos: {
        exibirFotosEquipamentos: showEquipmentsImages,
        exibirInformacoesComplementares: showAditionalInformation,
      },
      exibirAtividadesNRealizadas: showJustificationsOfNonRealizedActivities,
      recomendacoesFalhas: failuresAndEmergenciesRecommendations,
      documentosComplementares: additionalDocuments,
    };
  };

  const validateRequiredFields = ({ unit, systems, period, activitiesPlans, responsible1, responsible2 }) => {
    const requiredFields = [unit, systems, period, activitiesPlans, responsible1.id, responsible1.document];
    if (isSecondResponsibleFormActive) {
      requiredFields.push(responsible2.id, responsible2.document);
      responsible1.document;
    }
    let invalidFieldsCount = requiredFields.filter(element => !element || element.length === 0).length;
    if (invalidFieldsCount === 1) {
      setToastList(() => [
        createToast({
          type: 'error',

          message: 'Um campo obrigatório não foi preenchido.',
        }),
      ]);

      return true;
    } else if (invalidFieldsCount > 1) {
      setToastList(() => [
        createToast({
          type: 'error',
          message: 'Há campos obrigatórios não preenchidos.',
        }),
      ]);
      return true;
    }
    return false;
  };

  const onSubmit = values => {
    const hasError = validateRequiredFields(values);
    if (hasError) {
      return;
    }

    const payload = formatPayload(values);

    setToastList(prevState => [
      ...prevState,
      createToast({
        type: 'loading',
        message: 'Gerando arquivo...',
      }),
    ]);

    return sendPdfByEmail(payload);
    // return generatePDF(payload);
  };

  const applySavedFilter = data => {
    const {
      unit: savedUnit,
      unitGroup: savedUnitGroup,
      unitSubgroup: savedUnitSubgroup,
      showEquipmentsImages: savedShowEquipmentsImages,
      showAditionalInformation: savedShowAditionalInformation,
      showJustificationsOfNonRealizedActivities: savedShowJustificationsOfNonRealizedActivities,
      responsible1: savedResponsible1,
      responsible2: savedResponsible2,
      period: savedPeriod,
      extraDocuments: savedExtraDocuments,
      activitiesPlans: savedActivitiesPlans,
      systems: savedSystems,
    } = data;

    if (savedUnit) {
      setValue('unit', savedUnit);
    }

    if (savedSystems) {
      setValue('systems', savedSystems);
      fetchData();
    }
    if (savedUnitGroup) {
      setValue('unitGroup', savedUnitGroup);
    }

    if (savedUnitSubgroup) {
      setValue('unitSubgroup', savedUnitSubgroup);
    }

    if (savedShowEquipmentsImages) {
      setValue('showEquipmentsImages', savedShowEquipmentsImages);
    }

    if (savedShowAditionalInformation) {
      setValue('showAditionalInformation', savedShowAditionalInformation);
    }

    if (savedShowJustificationsOfNonRealizedActivities) {
      setValue('showJustificationsOfNonRealizedActivities', savedShowJustificationsOfNonRealizedActivities);
    }

    if (savedResponsible1) {
      setValue('responsible1', savedResponsible1);
    }

    if (savedResponsible2) {
      setValue('responsible2', savedResponsible2);
    }

    if (savedExtraDocuments) {
      setValue('extraDocuments', savedExtraDocuments);
    }

    if (savedPeriod) {
      setValue('period', savedPeriod);
    }

    if (savedActivitiesPlans) {
      setValue('activitiesPlans', savedActivitiesPlans);
    }
  };

  const resetFieldValues = () => {
    setValue('unitGroup', '');

    setValue('unitSubgroup', '');

    setValue('unit', '');

    setValue('systems', []);
    setValue('activitiesPlans', []);

    setValue('period', '');

    setValue('showAditionalInformation', false);

    setValue('showEquipmentsImages', false);

    setValue('showJustificationsOfNonRealizedActivities', false);

    setValue('responsibles', []);
    setValue('responsible1.id', {});
    setValue('responsible2.id', {});
    setValue('responsible1.document', {});
    setValue('responsible2.document', {});
    setValue('responsible1.certificate', {});
    setValue('responsible2.certificate', {});

    setCurrentSavedFilter('');

    fetchData();
  };

  const saveFilters = async () => {
    try {
      const formValues = getValues();

      const payload = formatPayload(formValues);
      const {
        filterName,
        unit,
        unitGroup,
        unitSubgroup,
        showEquipmentsImages,
        showAditionalInformation,
        showJustificationsOfNonRealizedActivities,
        period,
        systems,
        responsible1,
        responsible2,
        extraDocuments,
        activitiesPlans,
      } = payload;

      const companyId = headerFilters?.companies?.id;
      const userId = user?.id;

      await SavedFiltersService.createSavedFilter({
        companyId,
        userId,
        filterName,
        reportName,
        fields: {
          unit,
          unitGroup,
          unitSubgroup,
          showEquipmentsImages,
          showAditionalInformation,
          showJustificationsOfNonRealizedActivities,
          period,
          responsible1,
          responsible2,
          extraDocuments,
          activitiesPlans,
          systems,
        },
      });

      setToastList(prevState => [
        ...prevState,
        createToast({
          type: 'success',
          message: 'Filtros salvos com sucesso',
        }),
      ]);
    } catch (err) {
      setToastList(prevState => [
        ...prevState,
        createToast({
          type: 'error',
          message: 'Ocorreu um erro ao salvar os filtros',
        }),
      ]);
    }
  };

  const sendPdfByEmail = async payload => {
    let isGenerateReportSuccess = false;
    try {
      const {
        empresa,
        dataInicial,
        dataFinal,
        unidade,
        sistemas,
        ativos,
        login,
        exibirAtividadesNRealizadas,
        recomendacoesFalhas,
        documentosComplementares,
        planoAtividades,
        responsaveisTecnicos,
      } = payload;
      const response = await PmocService.sendPdfByEmail({
        login,
        empresa,
        dataInicial,
        dataFinal,
        unidade,
        sistemas,
        planoAtividades,
        responsaveisTecnicos,
        ativos,
        exibirAtividadesNRealizadas,
        recomendacoesFalhas,
        documentosComplementares,
        token: authStorage.token,
      });
      const { data } = response;
      // ! Verify with Ju which response leads to this error
      if (!data) {
        setToastList(prevState => [
          ...prevState,
          createToast({
            type: 'error',
            message: 'Não há dados para os filtros selecionados.',
          }),
        ]);
        return;
      }

      if (data === 'pmoc enviado para fila de processamento') {
        setIsSendPmocEmailSuccess(true);
        isGenerateReportSuccess = true;
      } else if (data === 'Relatorio Duplicado') {
        setDuplicatedReport(true);
      } else {
        throw new Error('sendPdfByEmail unexpected response');
      }
    } catch (err) {
      createGenericErrorToast(setToastList);
    } finally {
      isGenerateReportSuccess && Sentry.captureMessage('Relatório PMOC PDF baixado');
    }
  };

  const onSelectFilter = async selectedFilter => {
    const { id, name } = selectedFilter;

    try {
      const response = await SavedFiltersService.getSavedFilters({
        companyId: headerFilters?.companies?.id,
        filterSavedId: id,
      });

      applySavedFilter(response.data);

      setCurrentSavedFilter(() => name);
    } catch (err) {
      setToastList(prevState => [
        ...prevState,
        createToast({
          type: 'error',
          message: 'Ocorreu um erro ao buscar o filtro selecionado.',
        }),
      ]);
    } finally {
      setModalOptions(() => ({
        open: false,
      }));
    }
  };

  const [unitId, setUnitId] = useState(headerFilters?.units?.id || '');

  const populateFieldsStrategy = async () => {
    const companyId = headerFilters?.companies?.id;
    const unitGroupId = getValues('unitGroup');
    const unitSubgroupId = getValues('unitSubgroup');
    //  const unitId = getValues('unit');
    setUnitId(getValues('unit'));
    const systems = getValues('systems');
    if (!unitId) {
      return await Promise.all([
        FiltersService.getUnitGroups({
          companyId,
          ids: unitGroupId && [unitGroupId],
        }),
        FiltersService.getUnitSubgroups({
          companyId,
          ids: unitSubgroupId && [unitSubgroupId],
          unitGroupIds: unitGroupId && [unitGroupId],
        }),
        FiltersService.getUnits({
          companyId,
          ids: unitId && [unitId],
          unitGroupIds: unitGroupId && [unitGroupId],
          unitSubgroupIds: unitSubgroupId && [unitSubgroupId],
        }),
        ReportService.getGeneratedReports({
          usuarioId: user.id,
          tipos: [1, 7],
          token: authStorage.token,
        }),
      ]).then(values => ({
        unitGroups: values[0]?.data.map(({ nome, grupoUnidadeId }) => ({
          label: nome,
          value: grupoUnidadeId,
        })),
        unitSubgroups: values[1]?.data.map(({ nome, subGrupoUnidadeId }) => ({
          label: nome,
          value: subGrupoUnidadeId,
        })),
        units: values[2]?.data.map(({ nome, site }) => ({
          label: nome,
          value: site,
        })),
        generatedReports: values[3]?.data.sort((a, b) => {
          return a.emissao > b.emissao ? -1 : a.emissao < b.emissao ? 1 : 0;
        }),
      }));
    }
    return await Promise.all([
      FiltersService.getUnitGroups({
        companyId,
        ids: unitGroupId && [unitGroupId],
      }),
      FiltersService.getUnitSubgroups({
        companyId,
        ids: unitSubgroupId && [unitSubgroupId],
        unitGroupIds: unitGroupId && [unitGroupId],
      }),
      FiltersService.getUnits({
        companyId,
        ids: [unitId],
        unitGroupIds: unitGroupId && [unitGroupId],
        unitSubgroupIds: hasOnlyUnitsWithSubgroup ? unitSubgroupId && [unitSubgroupId] : '',
      }),
      FiltersService.getActivityResponsibles({
        companyId,
        unitId: unitId,
      }),
      FiltersService.getResponsibleARTCertificateDocuments({
        companyId,
        unitId: unitId,
      }),
      FiltersService.getResponsibleTRTCertificateDocuments({
        companyId,
        unitId: unitId,
      }),
      FiltersService.getSystems({
        companyId,
        unitIds: [unitId],
        unitGroupIds: unitGroupId && [unitGroupId],
        unitSubgroupIds: unitSubgroupId && [unitSubgroupId],
      }),
      FiltersService.getDocuments({
        companyId,
        unitId: unitId,
      }),
      systems?.length > 0 &&
        FiltersService.getPMOCActivitiesPlans({
          companyId,
          systemIds: systems,
          unitId: unitId,
        }),
      ReportService.getGeneratedReports({
        usuarioId: user.id,
        tipos: [1, 7],
        token: authStorage.token,
      }),
    ]).then(values => ({
      unitGroups: values[0]?.data.map(({ nome, grupoUnidadeId }) => ({
        label: nome,
        value: grupoUnidadeId,
      })),
      unitSubgroups: values[1]?.data.map(({ nome, subGrupoUnidadeId }) => ({
        label: nome,
        value: subGrupoUnidadeId,
      })),
      units: values[2]?.data.map(({ nome, site }) => ({
        label: nome,
        value: site,
      })),
      responsibles: values[3]?.data.map(({ nome, responsavelTecnico }) => ({
        label: nome,
        value: responsavelTecnico,
      })),
      responsiblesARTCertificateDocuments: values[4]?.data.map(({ anexoUrl, tag, documentoId }) => ({
        label: tag,
        key: documentoId,
        value: anexoUrl,
      })),
      responsiblesTRTCertificateDocuments: values[5]?.data.map(({ anexoUrl, tag, documentoId }) => ({
        label: tag,
        key: documentoId,
        value: anexoUrl,
      })),

      systems: values[6]?.data.map(({ nome, sistemaEmpresa }) => ({
        label: nome,
        value: sistemaEmpresa,
      })),
      documents: values[7]?.data.map(({ documentoId, tag, anexoUrl }) => ({
        label: tag,
        key: documentoId,
        value: anexoUrl,
      })),
      activitiesPlans: values[8]?.data?.map(({ nome, planoId }) => ({
        label: nome,
        value: planoId,
      })),
      generatedReports: values[9]?.data.sort((a, b) => {
        return a.emissao > b.emissao ? -1 : a.emissao < b.emissao ? 1 : 0;
      }),
    }));
  };

  const checkUnitsSubgroup = (units, fields, unitSubgroups) => {
    const adaptedUnits = adaptReportsApiOptions(units);
    fields.sort((a, b) => {
      return a.value - b.value;
    });
    adaptedUnits.sort((a, b) => {
      return a.value - b.value;
    });
    if (fields.length === adaptedUnits.length) {
      let isEqual = false;
      for (let i = 0; i < fields.length; i++) {
        if (fields[i].value === adaptedUnits[i].value) {
          isEqual = true;
        } else {
          isEqual = false;
          break;
        }
      }
      if (isEqual) {
        //setHasOnlyUnitsWithSubgroup(true);
        setValue('unitSubgroup', unitSubgroups[0].value);
        return adaptedUnits;
      } else {
        setHasOnlyUnitsWithSubgroup(false);
        setValue('unitSubgroup', '');
        return fields;
      }
    } else {
      setHasOnlyUnitsWithSubgroup(false);
      setValue('unitSubgroup', '');
      return fields;
    }
  };

  const populateFields = async () => {
    try {
      const fieldsData = await populateFieldsStrategy();

      const { unitSubgroups, unitGroups } = fieldsData;

      if (unitGroups?.length === 1) {
        setValue('unitGroup', unitGroups[0].value);
      }
      if (unitSubgroups?.length === 1) {
        //setValue('unitSubgroup', unitSubgroups[0].value);
        const { data: units } = await FiltersService.getUnits({
          companyId: headerFilters?.companies?.id,
          unitGroupIds: unitGroups[0]?.value,
          unitSubgroupIds: unitSubgroups[0]?.value,
        });
        const checkedUnits = checkUnitsSubgroup(units, fieldsData.units, unitSubgroups);
        fieldsData.units = checkedUnits;
      }
      setFields(prevState => ({
        ...prevState,
        ...fieldsData,
      }));
    } catch (err) {
      createGenericErrorToast(setToastList);
    }
  };

  const getModalOptionsData = async () => {
    const companyId = headerFilters?.companies?.id;
    const userId = user?.id;

    try {
      const response = await SavedFiltersService.findSavedFiltersByReportName({
        reportName,
        companyId,
        userId,
      });
      return response.data;
    } catch (err) {
      setToastList(prevState => [
        ...prevState,
        createToast({
          type: 'error',
          message: 'Ocorreu um erro ao buscar os filtros salvos. Tente novamente..',
        }),
      ]);
    }
  };

  const deleteSavedFilter = async selectedFilter => {
    const { id } = selectedFilter;

    const companyId = headerFilters?.companies?.id;

    try {
      await SavedFiltersService.removeSavedFilter({
        companyId,
        filterSavedId: id,
      });
      setToastList(prevState => [
        ...prevState,
        createToast({
          type: 'success',
          message: 'O filtro selecionado foi deletado com sucesso',
        }),
      ]);
    } catch (err) {
      setToastList(prevState => [
        ...prevState,
        createToast({
          type: 'error',
          message: 'Ocorreu um erro ao deletar o filtro selecionado. Tente novamente.',
        }),
      ]);
    } finally {
      setModalOptions({
        open: false,
      });
    }
  };

  const openModalSavedFilters = () =>
    setModalOptions(() => ({
      title: 'Filtros salvos',
      open: true,
    }));

  const fetchData = async () => {
    setGlobalComponentsContext(prevState => ({
      ...prevState,
      isLoading: true,
    }));
    // await resetFieldValues();
    try {
      const login = user?.name;
      // TODO VERIFY 503 ERROR WITH JU
      const { token } = authStorage;
      const { data } = await PmocService.validateLogin(login, token);
      if (data === 'Email Valido') {
        setIsEmailVerified(true);
        await populateFields();
      }
    } catch (err) {
      if (err.message.includes('Network Error')) {
        history.push('/conection-error');
      }
      createGenericErrorToast(setToastList);
    } finally {
      setGlobalComponentsContext(prevState => ({
        ...prevState,
        isLoading: false,
      }));
    }
    if (!headerFilters?.companies?.id) {
      createErrorToast(setToastList, 'Selecione uma empresa antes de continuar');
      return;
    }
  };

  useEffect(() => {
    fetchData();
    setIsFirstMount(false);
    // eslint-disable-next-line
  }, [errors, unitId]);

  const watchUnitAndSystems = useWatch({
    name: ['unit', 'systems'],
    control,
  });

  const watchResponsibles = useWatch({
    name: ['responsible1', 'responsible2'],
    control,
  });

  // Refactor if responsible limit increases
  const handleResponsible1CertificateTypeChange = () => {
    setValue('responsible1.document', '');
  };

  const handleResponsible2CertificateTypeChange = () => {
    setValue('responsible2.document', '');
  };

  const [hasOnlyUnitsWithSubgroup, setHasOnlyUnitsWithSubgroup] = useState(true);
  const isUnitSelected = getValues('unit') !== '';
  const isUnitSubgroupSelected = getValues('unitSubgroup') !== '';
  const isOnlyOneUnitGroupAvailable = fields?.unitGroups?.length === 1;
  const isOnlyOneUnitSubGroupAvailable = fields?.unitSubgroups?.length === 1;
  const doesNotHaveUnitGroup = fields?.unitGroups?.length === 0;
  const isUnitGroupDisabled =
    (isUnitSelected && isUnitSubgroupSelected) || isOnlyOneUnitGroupAvailable || isUnitSelected || doesNotHaveUnitGroup;
  const isUnitSubgroupDisabled = isUnitSelected || (isOnlyOneUnitSubGroupAvailable && hasOnlyUnitsWithSubgroup);
  // TODO
  const isPageDisabled = !isEmailVerified;

  const columns = useMemo(
    () => [
      {
        Header: 'Arquivo',
        accessor: 'arquivo',
      },
      {
        Header: 'Data/hora de emissão',
        accessor: 'dataHoraEmissao',
      },
      {
        Header: 'Unidade(s)',
        accessor: 'unidade',
      },
      {
        Header: 'Período',
        accessor: 'periodo',
      },
    ],
    [],
  );
  const downloadReport = async (generatedReport, e) => {
    e.preventDefault();
    const result = await ReportService.getUrlToDownload({
      token,
      nomeArquivo: generatedReport.nomeArquivo,
      tipo: generatedReport.tipo,
    });
    window.open(result.data);
    return false;
  };
  const getDate = emissao => {
    const dateString = new Date(emissao);
    const date = dateString.toLocaleDateString();
    const time = dateString.toLocaleTimeString();
    return `${date} • ${time} `;
  };
  const handleRedoReport = async (id, e) => {
    e.preventDefault();
    await ReportService.redoReport({ id, token });
    updateGeneratedReports(e);
  };
  const dataTable = fields?.generatedReports?.map(generatedReport => ({
    arquivo:
      generatedReport.status === 2 ? (
        <div className="download-report">
          <DownloadIcon />
          <DownloadButton onClick={e => downloadReport(generatedReport, e)}>
            <b>Baixar Relatório</b>
          </DownloadButton>
        </div>
      ) : generatedReport.status === 4 ? (
        <div className="download-report">
          <StyledWarningIcon />
          <StatusWarningInfo>
            ERRO: TENTE NOVAMENTE
            <RedoReportButton onClick={e => handleRedoReport(generatedReport.id, e)}>
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="white" stroke="#E5E5E5" />
                <path
                  d="M21.7144 10H20.5716C20.4287 10 20.2859 10.1429 20.2859 10.2857C20.2859 10.3095 20.2859 10.3095 20.2859 10.3095L20.3811 12.2857C19.3097 11 17.6906 10.1905 15.9049 10.1905C12.643 10.1905 9.97635 12.8571 10.0002 16.119C10.0002 19.381 12.643 22 15.9049 22C17.4287 22 18.8097 21.4286 19.8573 20.5C19.9049 20.4286 19.9525 20.3571 19.9525 20.2857C19.9525 20.1905 19.9049 20.119 19.8573 20.0714L19.0478 19.2619C19.0002 19.2143 18.9287 19.1905 18.8573 19.1905C18.7859 19.1905 18.7144 19.2143 18.6668 19.2619C17.9287 19.9048 16.9525 20.2857 15.9049 20.2857C13.5716 20.2857 11.7144 18.4286 11.7144 16.0952C11.7144 13.7857 13.5716 11.9048 15.9049 11.9048C17.3335 11.9048 18.6192 12.6429 19.3811 13.7619L16.9525 13.6429C16.9525 13.6429 16.9525 13.6429 16.9287 13.6429C16.7859 13.6429 16.643 13.7857 16.643 13.9286H16.6668V15.0714C16.6668 15.2143 16.7859 15.3571 16.9525 15.3571H21.7144C21.8573 15.3571 22.0002 15.2143 22.0002 15.0714V10.2857C22.0002 10.1429 21.8573 10 21.7144 10Z"
                  fill="#1E1E1E"
                />
              </svg>
            </RedoReportButton>
          </StatusWarningInfo>
        </div>
      ) : generatedReport.status === 5 ? (
        <div className="download-report">
          <StyledWarningIcon />
          <StatusWarningInfo>ERRO: SEM DADOS P/ EMISSÃO</StatusWarningInfo>
        </div>
      ) : (
        <div className="download-report">
          <Spinner />
          <StatusInfo>GERANDO RELATÓRIO</StatusInfo>
        </div>
      ),
    dataHoraEmissao: getDate(generatedReport.emissao),
    unidade: generatedReport.unidades,
    periodo: generatedReport.periodo,
  }));
  const closeAtentionModal = () => {
    setDuplicatedReport(false);
  };
  const sendEmail = () => {
    setIsSendPmocEmailSuccess(false);
    setActive(true);
  };
  const closeModal = () => {
    setIsSendPmocEmailSuccess(false);
    setActive(true);
  };
  const updateGeneratedReports = async e => {
    e.preventDefault();
    setGlobalComponentsContext(prevState => ({
      ...prevState,
      isLoading: true,
    }));
    const fieldsData = await ReportService.getGeneratedReports({
      usuarioId: user.id,
      tipos: [1, 7],
      token: authStorage.token,
    }).then(values => ({
      generatedReports: values?.data.sort((a, b) => {
        return a.emissao > b.emissao ? -1 : a.emissao < b.emissao ? 1 : 0;
      }),
    }));
    setFields(prevState => ({
      ...prevState,
      ...fieldsData,
    }));
    setActive(true);
    setGlobalComponentsContext(prevState => ({
      ...prevState,
      isLoading: false,
    }));
  };
  const updateGeneratedReports60S = async () => {
    setGlobalComponentsContext(prevState => ({
      ...prevState,
      isLoading: true,
    }));
    const fieldsData = await ReportService.getGeneratedReports({
      usuarioId: user.id,
      tipos: [1, 7],
      token: authStorage.token,
    }).then(values => ({
      generatedReports: values?.data.sort((a, b) => {
        return a.emissao > b.emissao ? -1 : a.emissao < b.emissao ? 1 : 0;
      }),
    }));
    setFields(prevState => ({
      ...prevState,
      ...fieldsData,
    }));
    setActive(true);
    setGlobalComponentsContext(prevState => ({
      ...prevState,
      isLoading: false,
    }));
  };
  const tabs = [
    {
      id: 0,
      title: 'Gerar relatório',
      content: (
        <>
          <ReportContainerColumn justifyContent="flex-end" gridColumnStart={2}>
            <ReportContainerFields>
              <FieldRow marginBottom="1rem">
                <FormGroup label="Grupo de unidades" disabled={isUnitGroupDisabled}>
                  <Controller
                    render={props => (
                      <Select
                        {...props}
                        size="small"
                        placeholder="Seleção opcional"
                        options={fields?.unitGroups}
                        disabled={isUnitGroupDisabled}
                        cleanFields={resetFieldValues}
                        setValueSubGroup={setValue}
                        defaultValue={isFirstMount ? props.defaultValue : ''}
                        onChange={value => {
                          props.onChange(value);
                          fetchData();
                        }}
                        ref={null}
                      />
                    )}
                    name="unitGroup"
                    control={control}
                    defaultValue={headerFilters?.unitGroups?.id || ''}
                  />
                </FormGroup>
              </FieldRow>

              <FieldRow marginBottom="1rem">
                <FormGroup label="Subgrupo de unidades" disabled={isUnitSubgroupDisabled}>
                  <Controller
                    render={props => (
                      <Select
                        {...props}
                        size="small"
                        placeholder="Seleção opcional"
                        disabled={isUnitSubgroupDisabled}
                        hasOnlyUnitsWithSubgroup={hasOnlyUnitsWithSubgroup}
                        options={fields?.unitSubgroups}
                        defaultValue={isFirstMount ? props.defaultValue : ''}
                        onChange={value => {
                          props.onChange(value);
                          fetchData();
                        }}
                        ref={null}
                      />
                    )}
                    name="unitSubgroup"
                    control={control}
                    defaultValue={headerFilters?.unitSubgroups?.id || ''}
                  />
                </FormGroup>
              </FieldRow>
              <FieldRow marginBottom="1rem">
                <FormGroup label="Unidade de manutenção" disabled={fields?.units?.length <= 0} isRequired>
                  <Controller
                    render={props => (
                      <Select
                        {...props}
                        size="small"
                        placeholder="Seleção obrigatória"
                        options={fields?.units}
                        defaultValue={isFirstMount ? props.defaultValue : ''}
                        onChange={value => {
                          props.onChange(value);
                          fetchData();
                        }}
                        onInputClear={() => {
                          setFields(prevFields => ({
                            unitGroups: prevFields.unitGroups,
                            unitSubgroups: prevFields.unitSubgroups,
                            units: [],
                          }));
                        }}
                        ref={null}
                      />
                    )}
                    name="unit"
                    control={control}
                    defaultValue={headerFilters?.units?.id || ''}
                    rules={{ required: true }}
                  />
                </FormGroup>
              </FieldRow>
              <FieldRow marginBottom="1rem">
                <FormGroup label="Sistema" isRequired disabled={!isUnitSelected}>
                  <Controller
                    render={props => (
                      <MultiSelect
                        {...props}
                        size="small"
                        placeholder="Seleção obrigatória"
                        options={fields?.systems}
                        disabled={!isUnitSelected}
                        onChange={value => {
                          props.onChange(value);
                          fetchData();
                        }}
                        ref={register}
                      />
                    )}
                    name="systems"
                    control={control}
                    defaultValue={[]}
                    rules={{ required: true }}
                  />
                </FormGroup>
              </FieldRow>
            </ReportContainerFields>
          </ReportContainerColumn>

          <LineSeparator show={watch('unit') && watch('systems')?.length > 0} />
          {watchUnitAndSystems.unit && watchUnitAndSystems.systems.length > 0 ? (
            <ReportContainerColumn>
              <ReportContainerFields>
                <Accordion titulo="Período" isRequired>
                  <GridColumn size={1} columnGap="1rem" rowGap="1rem">
                    <FormGroup label="Período do PMOC" isRequired>
                      <Controller
                        render={props => <DateRangePicker {...props} size="small" placeholder="Seleção obrigatória" />}
                        name="period"
                        control={control}
                        defaultValue={currentSavedFilter?.period || ''}
                      />
                    </FormGroup>
                  </GridColumn>
                </Accordion>
                <FieldRow marginBottom="1rem" />
                <Accordion titulo="Planos de atividades" isRequired>
                  <GridColumn size={1} columnGap="1rem" rowGap="1rem">
                    <FormGroup isRequired label="Planos de atividades" disabled={fields?.activitiesPlans?.length <= 0}>
                      <Controller
                        render={props => (
                          <MultiSelect
                            {...props}
                            size="small"
                            placeholder="Seleção obrigatória"
                            options={fields?.activitiesPlans}
                            ref={null}
                          />
                        )}
                        name="activitiesPlans"
                        control={control}
                        defaultValue={[]}
                        rules={{ required: true }}
                      />
                    </FormGroup>
                  </GridColumn>
                </Accordion>
                <FieldRow marginBottom="1rem" />
                <Accordion titulo="Exibir em ativos">
                  <GridColumn size={2} columnGap="1rem">
                    <Switch label="Exibir fotos dos equipamentos" name="showEquipmentsImages" ref={register()} />
                    <Switch label="Exibir informações adicionais" name="showAditionalInformation" ref={register()} />
                  </GridColumn>
                </Accordion>
                <FieldRow marginBottom="1rem" />
                <Accordion titulo="Exibir em programação de atividades">
                  <GridColumn size={1} columnGap="1rem">
                    <Switch
                      label="Exibir justificativas de atividades não realizadas"
                      name="showJustificationsOfNonRealizedActivities"
                      ref={register()}
                    />
                  </GridColumn>
                </Accordion>
                <FieldRow marginBottom="1rem" />
                <Accordion titulo="Responsável técnico" isRequired>
                  <StyledResponsibleFormContainer key={'responsible-form-1'}>
                    <GridColumn size={1} columnGap="1rem" rowGap="1rem">
                      <FormGroup label="Responsável Técnico" disabled={fields?.responsibles?.length <= 0} isRequired>
                        <Controller
                          render={props => (
                            <Select
                              {...props}
                              size="small"
                              placeholder="Seleção obrigatória"
                              options={fields?.responsibles}
                              defaultValue={isFirstMount ? props.defaultValue : ''}
                              onChange={value => {
                                props.onChange(value);
                                fetchData();
                              }}
                              ref={null}
                            />
                          )}
                          name={'responsible1.id'}
                          defaultValue=""
                          control={control}
                        />
                        <InfoLink
                          link="https://leankeep.movidesk.com/kb/pt-br/article/99881/como-definir-um-responsavel-tecnico-para-um-sistema?ticketId=&q="
                          text="Saiba como cadastrar o Responsável Técnico"
                        />
                      </FormGroup>

                      <StyledCertificateTypeRadioContainer>
                        <b>Tipo de certificação:</b>
                        <Radio
                          text="ART"
                          name={'responsible1.certificate'}
                          value="ART"
                          onChange={e => handleResponsible1CertificateTypeChange(e.target.value)}
                          ref={register()}
                        />
                        <Radio
                          text="TRT"
                          name={'responsible1.certificate'}
                          value="TRT"
                          onChange={e => handleResponsible1CertificateTypeChange(e.target.value)}
                          ref={register()}
                        />
                      </StyledCertificateTypeRadioContainer>

                      <FormGroup
                        label="Anexar documento (cadastrado no Leankeep)"
                        isRequired
                        showTooltip={true}
                        tooltipMessage="Nenhum documento disponível"
                      >
                        <Controller
                          render={props => (
                            <Select
                              {...props}
                              size="small"
                              placeholder="Seleção obrigatória"
                              name={'documents'}
                              options={
                                watchResponsibles.responsible1.certificate === 'ART'
                                  ? fields?.responsiblesARTCertificateDocuments
                                  : fields?.responsiblesTRTCertificateDocuments
                              }
                              ref={register()}
                            />
                          )}
                          name={'responsible1.document'}
                          control={control}
                          defaultValue=""
                        />
                        <InfoLink
                          link="https://leankeep.movidesk.com/kb/article/100658/como-utilizar-documentos?ticketId=&q=documento"
                          text="Saiba como cadastrar o documento ART/TRT"
                        />
                      </FormGroup>
                    </GridColumn>
                  </StyledResponsibleFormContainer>
                  {isSecondResponsibleFormActive && (
                    <StyledResponsibleFormContainer key={'responsible-form-2'}>
                      <RemoveSecondResponsibleButton
                        onClick={() => setIsSecondResponsibleFormActive(false)}
                        width={9}
                        height={9}
                      />
                      <GridColumn size={1} columnGap="1rem" rowGap="1rem">
                        <FormGroup label="Responsável Técnico" disabled={fields?.responsibles?.length <= 0} isRequired>
                          <Controller
                            render={props => (
                              <Select
                                {...props}
                                size="small"
                                placeholder="Seleção obrigatória"
                                options={fields?.responsibles}
                                defaultValue={isFirstMount ? props.defaultValue : ''}
                                onChange={value => {
                                  props.onChange(value);
                                  fetchData();
                                }}
                                ref={register()}
                              />
                            )}
                            name={'responsible2.id'}
                            defaultValue=""
                            control={control}
                          />
                        </FormGroup>
                        <StyledCertificateTypeRadioContainer>
                          <b>Tipo de certificação:</b>
                          <Radio
                            text="ART"
                            name={'responsible2.certificate'}
                            value="ART"
                            onChange={e => handleResponsible2CertificateTypeChange(e.target.value)}
                            ref={register()}
                          />
                          <Radio
                            text="TRT"
                            name={'responsible2.certificate'}
                            value="TRT"
                            onChange={e => handleResponsible2CertificateTypeChange(e.target.value)}
                            ref={register()}
                          />
                        </StyledCertificateTypeRadioContainer>

                        <FormGroup
                          label="Anexar documento (cadastrado no Leankeep)"
                          showTooltip={true}
                          tooltipMessage="Nenhum documento disponível"
                          disabled={fields?.reponsible2Documents?.length <= 0}
                          isRequired
                        >
                          <Controller
                            render={props => (
                              <Select
                                {...props}
                                size="small"
                                disabled={fields?.reponsible2Documents?.length <= 0}
                                placeholder="Seleção obrigatória"
                                name={'documents'}
                                options={
                                  watchResponsibles.responsible2.certificate === 'ART'
                                    ? fields?.responsiblesARTCertificateDocuments
                                    : fields?.responsiblesTRTCertificateDocuments
                                }
                                ref={register()}
                              />
                            )}
                            name={'responsible2.document'}
                            control={control}
                            defaultValue=""
                          />
                        </FormGroup>
                      </GridColumn>
                    </StyledResponsibleFormContainer>
                  )}

                  {isSecondResponsibleFormActive === false && (
                    <StyledAddResponsibleButton
                      onClick={e => {
                        e.preventDefault();
                        setIsSecondResponsibleFormActive(true);
                      }}
                    >
                      + Adicionar mais um responsável técnico
                    </StyledAddResponsibleButton>
                  )}
                </Accordion>
                <FieldRow marginBottom="1rem" />
                <Accordion titulo="Recomendações para falhas e emergências">
                  <GridColumn size={1} columnGap="1rem">
                    <Controller
                      render={props => (
                        <Textarea
                          {...props}
                          size="large"
                          tabIndex={0}
                          placeholder="Escreva recomendações em situações de falha do equipamento ou emergências"
                        />
                      )}
                      name={'failuresAndEmergenciesRecommendations'}
                      control={control}
                      defaultValue=""
                    />
                  </GridColumn>
                </Accordion>
                <FieldRow marginBottom="1rem" />
                <Accordion titulo="Documentos Complementares">
                  {/* <InfoLink
                    link="https://leankeep.movidesk.com/kb/pt-br/article/97096/como-gerar-o-pmoc-no-leankeep"
                    text="Documentos complementares do PMOC exigidos por lei"
                  /> */}
                  <GridColumn size={1} columnGap="1rem" rowGap="1rem">
                    <FormGroup
                      label="Anexar documentos (cadastrado no Leankeep)"
                      showTooltip={true}
                      tooltipMessage="Nenhum documento disponível"
                      disabled={fields?.documents?.length <= 0}
                    >
                      <Controller
                        render={props => (
                          <MultiSelect
                            {...props}
                            size="small"
                            disabled={fields?.documents?.length <= 0}
                            placeholder="Seleção opcional"
                            options={fields?.documents}
                            ref={register()}
                          />
                        )}
                        name={'extraDocuments'}
                        control={control}
                        defaultValue=""
                      />
                    </FormGroup>
                  </GridColumn>
                </Accordion>
                <FieldRow marginBottom="1rem" />
              </ReportContainerFields>
            </ReportContainerColumn>
          ) : (
            <ReportContainerFillFields />
          )}
        </>
      ),
      propertyContent: 'formulario',
    },
    {
      id: 1,
      title: 'Relatórios gerados',
      idName: 'abaGerados',
      content: (
        <>
          <ReportTable
            title="Histórico dos últimos 90 dias:"
            columns={columns}
            data={dataTable}
            updateGeneratedReports={updateGeneratedReports}
          />
        </>
      ),
      propertyContent: 'tabela',
    },
  ];
  //const isRelGerados = window.location.search.includes('relGerados');
  const queryString = useLocation().search;
  const relgeradosId = Number(new URLSearchParams(queryString).get('relGerados'));
  const activeTab = useState(relgeradosId === 1 ? tabs[1] : tabs[0]);
  const [autoReload, setAutoReload] = useState(tabs[0].id);
  useEffect(() => {
    const intervalUpdate = setInterval(async () => {
      if (fields.generatedReports.some(element => element.status === 1 || element.status == 3) && autoReload === 1) {
        await updateGeneratedReports60S();
      }
    }, 60000);
    return () => clearInterval(intervalUpdate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoReload]);

  const emailNotVerifiedElement = (
    <EmailNotVerifiedWarningContainer>
      <svg width="80" height="88" viewBox="0 0 80 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.75436e-05 30.1139V57.8454C-0.00416577 60.7046 0.739864 63.5143 2.15712 65.9914C3.57437 68.4686 5.61477 70.5256 8.07267 71.9552L31.9273 85.8209C34.3817 87.2485 37.1659 88 40 88C42.8341 88 45.6183 87.2485 48.0727 85.8209L71.9273 71.9552C74.3852 70.5256 76.4256 68.4686 77.8429 65.9914C79.2601 63.5143 80.0042 60.7046 80 57.8454V30.1139C79.9971 27.2617 79.2497 24.4603 77.8328 21.9909C76.4159 19.5216 74.3793 17.471 71.9273 16.0448L48.0727 2.17907C45.6183 0.751537 42.8341 0 40 0C37.1659 0 34.3817 0.751537 31.9273 2.17907L8.07267 16.2481C5.65006 17.6568 3.63231 19.6755 2.21715 22.1062C0.802002 24.5368 0.0379999 27.2962 1.75436e-05 30.1139Z"
          fill="#EAE8E5"
        />
        <path
          d="M58.1797 39.5833C56.293 41.0833 53.9141 42.9167 45.5469 49.0833C43.9062 50.3333 40.8711 53.0833 38 53.0833C35.0469 53.0833 32.0938 50.3333 30.3711 49.0833C22.0039 42.9167 19.625 41.0833 17.7383 39.5833C17.4102 39.3333 17 39.5833 17 40V57C17 59.25 18.7227 61 20.9375 61H55.0625C57.1953 61 59 59.25 59 57V40C59 39.5833 58.5078 39.3333 58.1797 39.5833ZM38 50.3333C39.8867 50.4167 42.5938 47.9167 43.9883 46.9167C54.8984 38.9167 55.7188 38.1667 58.1797 36.1667C58.6719 35.8333 59 35.25 59 34.5833V33C59 30.8333 57.1953 29 55.0625 29H20.9375C18.7227 29 17 30.8333 17 33V34.5833C17 35.25 17.2461 35.8333 17.7383 36.1667C20.1992 38.1667 21.0195 38.9167 31.9297 46.9167C33.3242 47.9167 36.0312 50.4167 38 50.3333Z"
          fill="#AAAAAA"
        />
        <circle cx="56" cy="32" r="13.5" fill="#EC6655" stroke="#EAE8E5" strokeWidth="3" />
        <path
          d="M53.334 24.7439L53.8188 31.3714C53.8188 31.7908 54.0613 32.0005 54.5461 32.0005H57.4552C57.94 32.0005 58.1825 31.7908 58.1825 31.3714L58.6673 24.7439C58.6673 24.5152 58.5865 24.3436 58.4249 24.2292C58.3037 24.0767 58.1421 24.0005 57.94 24.0005H54.0613C53.8592 24.0005 53.6774 24.0767 53.5158 24.2292C53.3946 24.3436 53.334 24.5152 53.334 24.7439Z"
          fill="white"
        />
        <path
          d="M56.0007 34.6675C56.735 34.6675 57.3533 34.938 57.8557 35.4791C58.3968 35.9815 58.6673 36.5998 58.6673 37.3341C58.6673 38.0684 58.3968 38.7061 57.8557 39.2472C57.3533 39.7496 56.735 40.0008 56.0007 40.0008C55.2664 40.0008 54.6287 39.7496 54.0876 39.2472C53.5852 38.7061 53.334 38.0684 53.334 37.3341C53.334 36.5998 53.5852 35.9815 54.0876 35.4791C54.6287 34.938 55.2664 34.6675 56.0007 34.6675Z"
          fill="white"
        />
      </svg>
      <div>Para exportar o PMOC é necessário ter um e-mail válido cadastrado no seu perfil.</div>
      <span>Se for preciso peça a ajuda de um administrador ou fale conosco.</span>
      <Button theme="primary" onClick={goback}>
        <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 5H1" stroke={colors.white} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M5 1L1 5L5 9" stroke={colors.white} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Voltar
      </Button>
    </EmailNotVerifiedWarningContainer>
  );
  const knowMorePage = e => {
    e.preventDefault();
    window.open('https://leankeep.movidesk.com/kb/article/97096/como-gerar-o-pmoc-no-leankeep?ticketId=&q=pmoc');
  };

  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  return (
    <>
      {isLoading && <Loading />}

      <PageWrapper background={colors.pampas}>
        <MobileNavbar />
        {/* <Menu /> */}
        <NewMenu setIsSubMenuOpen={setIsSubMenuOpen} />
        <HeaderFiltersPage location={pathname} isSubMenuOpen={isSubMenuOpen}>
          <Header>
            <GoBackButton onClick={() => goback()}>
              <svg width="12" height="10" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.75258 0.341509C10.1163 0.757146 10.0741 1.38891 9.6585 1.75259L2.51859 8.00001L9.6585 14.2474C10.0741 14.6111 10.1163 15.2429 9.75258 15.6585C9.3889 16.0742 8.75713 16.1163 8.3415 15.7526L0.341495 8.75259C0.12448 8.5627 0 8.28838 0 8.00001C0 7.71165 0.12448 7.43733 0.341495 7.24744L8.3415 0.247437C8.75713 -0.116245 9.3889 -0.0741276 9.75258 0.341509Z"
                  fill="black"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 8C0 7.44772 0.447715 7 1 7H23C23.5523 7 24 7.44772 24 8C24 8.55228 23.5523 9 23 9H1C0.447715 9 0 8.55228 0 8Z"
                  fill="black"
                />
              </svg>
            </GoBackButton>
            <PageHeader title="PMOC - Plano de Manutenção, Operação e Controle" />
            <KnowMoreButton onClick={e => knowMorePage(e)}>
              SAIBA MAIS
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.56522 0C6.98896 0 6.52174 0.467217 6.52174 1.04348C6.52174 1.61974 6.98896 2.08696 7.56522 2.08696H8.4375L5.5231 5.00136C5.11562 5.40884 5.11562 6.06942 5.5231 6.4769C5.72658 6.68038 5.994 6.78261 6.26087 6.78261C6.52774 6.78261 6.79516 6.68038 6.99864 6.4769L9.91304 3.5625V4.43478C9.91304 5.01104 10.3803 5.47826 10.9565 5.47826C11.5328 5.47826 12 5.01104 12 4.43478V1.04348C12 0.467217 11.5328 0 10.9565 0H7.56522ZM2.34783 0.521739C1.05313 0.521739 0 1.57513 0 2.86957V9.65217C0 10.9466 1.05313 12 2.34783 12H9.13043C10.4251 12 11.4783 10.9466 11.4783 9.65217V8.54348C11.4783 7.96722 11.011 7.5 10.4348 7.5C9.85852 7.5 9.3913 7.96722 9.3913 8.54348V9.65217C9.3913 9.79591 9.27444 9.91304 9.13043 9.91304H2.34783C2.20383 9.91304 2.08696 9.79591 2.08696 9.65217V2.86957C2.08696 2.72583 2.20383 2.6087 2.34783 2.6087H3.45652C4.03278 2.6087 4.5 2.14148 4.5 1.56522C4.5 0.988957 4.03278 0.521739 3.45652 0.521739H2.34783Z"
                  fill="#F38A00"
                />
              </svg>
            </KnowMoreButton>
          </Header>
          <ReportContainerTabs
            tabs={tabs}
            setAutoReload={setAutoReload}
            autoReload={autoReload}
            isPageDisabled={isPageDisabled}
            activeTab={activeTab[0].id}
            exportTitle="Exportar Relatório"
            onSubmit={handleSubmit(onSubmit)}
            currentSavedFilter={currentSavedFilter}
            useSavedFilters={openModalSavedFilters}
            cleanSavedFilter={resetFieldValues}
            activeAfterSendEmail={active}
            setActiveAfterSendEmail={setActive}
            saveFilter={saveFilters}
            cleanFields={resetFieldValues}
            emailNotVerifiedElement={emailNotVerifiedElement}
            //onBack={goback}
            isClearFiltersBtnActive={!isPageDisabled}
            formId={reportName}
            refInputFilterName={register({
              required: true,
            })}
            renderFooter={watchUnitAndSystems.unit && watchUnitAndSystems.systems.length > 0}
          >
            {isPageDisabled ? emailNotVerifiedElement : tabs}
          </ReportContainerTabs>

          {/* <ReportContainer
            title="PMOC - Plano de Manutenção, Operação e Controle"
            exportTitle="Exportar Relatório"
            onSubmit={handleSubmit(onSubmit)}
            currentSavedFilter={currentSavedFilter}
            useSavedFilters={openModalSavedFilters}
            cleanSavedFilter={resetFieldValues}
            saveFilter={saveFilters}
            cleanFields={resetFieldValues}
            onBack={goback}
            isClearFiltersBtnActive={!isPageDisabled}
            formId={reportName}
            refInputFilterName={register({
              required: true,
            })}
            renderFooter={watchUnitAndSystems.unit && watchUnitAndSystems.systems.length > 0}
          >
            {isPageDisabled ? emailNotVerifiedElement : tabs[0].content}
          </ReportContainer> */}
        </HeaderFiltersPage>
      </PageWrapper>

      <Toast toastList={toastList} autoDelete dismissTime={7000} />

      <FilterModal
        options={modalOptions}
        closeModal={() =>
          setModalOptions(() => ({
            open: false,
          }))
        }
        onSelect={onSelectFilter}
        hasDeleteBtn
        onDelete={deleteSavedFilter}
        getData={getModalOptionsData}
      />

      <SendPmocEmailSuccessModal
        hasHeader
        title="Estamos preparando o seu relatório"
        icon={<EmailSuccessIcon />}
        size={{ width: '618px' }}
        open={isSendPmocEmailSuccess}
        closeModal={() => closeModal()}
      >
        <p>
          Assim que estiver pronto, o arquivo ficará disponível na aba de “Relatórios gerados” e enviaremos um aviso
          para o e-mail cadastrado em sua conta.{' '}
        </p>
        <Button theme="primary" onClick={() => sendEmail()}>
          Entendi
        </Button>
      </SendPmocEmailSuccessModal>
      <AtentionModal
        hasHeader
        title="O relatório já está sendo gerado"
        icon={<EmailAtentionIcon />}
        size={{ width: '554px' }}
        success={true}
        open={duplicatedReport}
        closeModal={() => setDuplicatedReport(false)}
      >
        <p>Já existe um relatório com esses dados sendo gerado, portanto essa nova requisição foi cancelada.</p>
        <Button theme="primary" onClick={() => closeAtentionModal()}>
          Entendi
        </Button>
      </AtentionModal>
    </>
  );
};

export { Pmoc };
